import { gql } from '@apollo/client';
import { ASYNC_TASK_FRAGMENT } from '../../../../components/AsyncTask';

export const IMPORT_HEALTH_CHECKUP_INSTITUTION_CSV = gql`
  mutation importHealthCheckupInstitutionCsv($input: ImportHealthCheckupInstitutionCsvInput!) {
    importHealthCheckupInstitutionCsv(input: $input) {
      client {
        id
        asyncTask {
          ...AsyncTaskFields
        }
      }
    }
  }
  ${ASYNC_TASK_FRAGMENT}
`;
